// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c1bc225c","453":"903d9734","455":"e58cf320","977":"18af804b"}[chunkId] + ".chunk.js";
};